import {  Component, Injectable                 } from '@angular/core';
import {  FormBuilder, FormGroup, Validators    } from '@angular/forms';
import {  ChartType                             } from 'chart.js';
import {  Label, SingleDataSet                  } from 'ng2-charts';
import {  MesaAyudaCrudService                  } from '../../../data/service/mesa-ayuda-crud.service';
import {  TotalNivelesIncidenciasInterface      } from '../../../model/MesaAyudaInterfaces/totalNivelesXincidenciaInterface';
import {  NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter
{
  parse(value: string): NgbDateStruct
  {
    if (value)
    {
      const dateParts = value.trim().split("/");
            if (dateParts.length === 1 && isNumber(dateParts[0]))
              return  {
                        day   : toInteger(dateParts[0]),
                        month : 0,
                        year  : 0
                      };
      else  if ( dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1]) )
              return  {
                        day   : toInteger(dateParts[0]),
                        month : toInteger(dateParts[1]),
                        year  : 0
                      };
      else  if ( dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2]) )
              return  {
                        day   : toInteger(dateParts[0]),
                        month : toInteger(dateParts[1]),
                        year  : toInteger(dateParts[2])
                      };
    }
    return  {
              day   : 0,
              month : 0,
              year  : 0
            };
  }

  format(date: NgbDateStruct): string
  {
    return date? `${isNumber(date.day) ? padNumber(date.day) : ""}/${isNumber(date.month) ? padNumber(date.month) : ""}/${date.year}`: "";
  }
}
export function toInteger(value : any     ) : number { return parseInt(`${value}`, 10); }
export function isNumber(value  : any     ) : value is number { return !isNaN(toInteger(value)); }
export function padNumber(value : number  ) : string { if (isNumber(value)) { return `0${value}`.slice(-2); } else { return ""; } }
@Component({
  selector: 'app-serviciosXniveles',
  templateUrl: './serviciosXniveles.component.html'
})
export class ServiciosXnivelesComponent
{
  cargarLoader            : boolean                             = false;
  TotalNivelesIncidencia  : TotalNivelesIncidenciasInterface[]  = [];
  dLabels                 : Label[]                             = [];
  dData                   : SingleDataSet                       = new Array(20);
  dType                   : ChartType                           = 'doughnut';
  gTotal                  : number                              = 0;
  fechaInicio             : string                              = "";
  fechaFin                : string                              = "";
  buscarForm              : FormGroup;

  constructor(
    private _mesaAyudaCrud  : MesaAyudaCrudService,
    private fb              : FormBuilder
  )
  {
    this.buscarForm = this.fb.group({ lblFechaInicio : [ , [ Validators.required ] ], lblFechaFin : [ , [ Validators.required ] ] });
  }

  ValidaCampo( campo:string ) : boolean | null { return this.buscarForm.controls[campo].errors && this.buscarForm.controls[campo].touched; }

  limpiarVariables()          : void
  {
    this.cargarLoader           = true;
    this.fechaInicio            = "";
    this.fechaFin               = "";

    this.gTotal                 = 0;
    this.TotalNivelesIncidencia = [];
    this.dLabels                = [];
    this.dData                  = [];
  }

  buscar()                    : void
  {
    if( this.buscarForm.valid )
    {
      this.limpiarVariables();

      let aFechaInicio  = this.buscarForm.controls['lblFechaInicio' ].value;
      let aFechaFin     = this.buscarForm.controls['lblFechaFin'    ].value;
      this.fechaInicio  = `${aFechaInicio[  'year']}-${aFechaInicio[  'month']}-${aFechaInicio[ 'day']} 00:00:00`;
      this.fechaFin     = `${aFechaFin[     'year']}-${aFechaFin[     'month']}-${aFechaFin[    'day']} 23:59:59`;

      this.dibujarGrafica();
    }
    else
      this.buscarForm.markAllAsTouched();
  }

  diaAnterior()               : void
  {
    this.limpiarVariables();

    var date = new Date();
    let DIA_EN_MILISEGUNDOS = 24*60*60*1000;
    let ayer = new Date(date.getTime() - DIA_EN_MILISEGUNDOS);

    this.fechaInicio = ayer.getFullYear()+"-"+(ayer.getMonth() + 1)+"-"+ayer.getDate()+" 00:00:00";
    this.fechaFin = ayer.getFullYear()+"-"+(ayer.getMonth() + 1)+"-"+ayer.getDate()+" 23:59:59";

    this.dibujarGrafica();
  }

  mesAnterior()               : void
  {
    this.limpiarVariables();

    var date = new Date();
    date.setMonth(date.getMonth() - 1);

    var primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
    var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    var sFechaAnterior = date.toISOString().substring(0, 7); /* Obtenemos la fecha en formato YYYY-mm */
    var aFechaAnterior = sFechaAnterior.split("-");

    this.fechaInicio = aFechaAnterior[0]+"-"+aFechaAnterior[1]+"-"+primerDia.getDate()+" 00:00:00";
    this.fechaFin = aFechaAnterior[0]+"-"+aFechaAnterior[1]+"-"+ultimoDia.getDate()+" 23:59:59";

    this.dibujarGrafica();
  }

  anioAnterior()              : void
  {
    this.limpiarVariables();

    var date = new Date();
    date.setFullYear(date.getFullYear() - 1);

    this.fechaInicio = date.getFullYear()+"-01-01 00:00:00";
    this.fechaFin = date.getFullYear()+"-12-31 23:59:59";
    
    this.dibujarGrafica();
  }

  dibujarGrafica()            : void
  {
    this._mesaAyudaCrud.NivelesServicioPorIncidencia(this.fechaInicio, this.fechaFin).subscribe( data => {

      data.forEach( ( total, i ) => {
        this.gTotal = this.gTotal + total.total;
        this.TotalNivelesIncidencia[i] = { nivelServicioId : total.nivelServicioId, nivelServicio : total.nivelServicio, total : total.total };
        this.dLabels[i] = "Nivel " + total.nivelServicio;
        this.dData[i] = total.total;
      });

      this.cargarLoader = false;
    });
  }
}
